export default __webpack_public_path__ + "static/media/ocean.7c05ff9bb395b0b8306a01708edee470.svg";